import dayjs from "dayjs";

export const formatTime = (time: dayjs.Dayjs | undefined): string => {
  if (!time) return "";
  return time.format("HH:mm");
};
